import { applyMiddleware, createStore } from "redux";
import { persistStore, persistReducer } from 'redux-persist'
import storage from 'redux-persist/lib/storage'
import CombinedReducer from "../Reducers/CombinedReducer";
import { composeWithDevTools } from "@redux-devtools/extension";
import thunk from "redux-thunk";


const middleware = [thunk];



const initialState = {
    isLoading: false,
    toastMessage: null,
    websiteURL: null,
    pid: '',
    title: '',
    backgroundColor: '',
    textColor: '',
    scaningProcess: false,
    reScaningProcess: false,
    isFromScript: false,
    scaningProcessPer: 0,
    screenShot: null,
    isPaidFree: 0,
    standard: "WCAG 2.0, 2.1 & 2.2",
    levelFailCounts: null,
    levelFailCountsFixedByWidget: null,
    formSubmitFlag: false,
    lang: null,
    ispidLoading: false,
}

const persistConfig = {
    key: 'root',
    storage: storage,
    blacklist: ['isLoading', 'toastMessage', 'websiteURL', 'scaningProcess', 'scaningProcessPer', 'reScaningProcess', 'screenShot', 'isWidget', 'isPaid', 'standard', 'levelFailCounts', 'levelFailCountsFixedByWidget']
}

const persistedReducer = persistReducer(persistConfig, CombinedReducer)



const store = createStore(
    persistedReducer,
    initialState,
    composeWithDevTools(applyMiddleware(...middleware))
)

let persistor = persistStore(store)

export { store, persistor };